import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TamamlayiciHatirlatma from 'src/components/ComplementaryProductRecommend';
import DataAi from 'src/components/DataAi';
import GenericAnket from 'src/components/GenericSurvey';
import { loadBaslandiJob, saveBaslandiJob } from '../../../utils/storage/StartWorkOrder';
import CustomerInfo from './CustomerInfo';



function Summary({ FisNo, readonly, tasks}) {


  const tasksArray = Array.isArray(tasks?.tasks) ? tasks.tasks : [];

  let customer = readonly
    ? tasksArray.filter(d => Number(d.FisNo) === Number(FisNo))
    : (loadBaslandiJob() || []);


  if (!readonly && (!customer || customer.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      customer = loadBaslandiJob();
    }
  }

  const customerData = (Array.isArray(customer) && customer.length > 0) ? customer[0] : {};

  const [anketOpen, setAnketOpen] = React.useState(parseInt(customerData?.DurumKodu || 0) === 33);
  const [AiOpen, setAiOpen] = React.useState(true);









  const [tamamlayiciUrunHatirlatma, setTamamlayiciUrunHatırlatma] = React.useState(parseInt(customerData?.TAMAMLAYICI_URUN_HATIRLATMA || 0) === 1);
  if (!customerData || Object.keys(customerData).length === 0) {
    return null;
  }

  return (
    <div>
      <CustomerInfo customer={customerData} readonly={readonly} FisNoParam={FisNo} />
      <GenericAnket anketOpen={anketOpen} setAnketOpen={setAnketOpen} anketTitle="Ziyaret Anketi"
        anketId={90} basvuruNo={customerData?.BasvuruNo} birimKodu={customerData?.BIRIM_KODU} setFisNo={customerData?.FisNo}
      />
      <TamamlayiciHatirlatma anketOpen={tamamlayiciUrunHatirlatma} setAnketOpen={setTamamlayiciUrunHatırlatma} anketTitle="Tamamlayıcı Ürün Önerisi !"
        BASVURU_NO={customerData?.BasvuruNo} BIRIM_KODU={customerData?.BIRIM_KODU} KUL_MODEL_KODU={customerData?.KUL_MODEL_KODU}
      />
      {
        customerData?.DATAAI === 1 ? <DataAi AiOpen={AiOpen} setAiOpen={setAiOpen} FisNo={customerData?.FisNo} Telefon={customerData?.ArayanTelefonOffline} /> : ''
      }

    </div>

  );
}

Summary.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.string,
  tasks: PropTypes.object
};


export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Summary);
